// extracted by mini-css-extract-plugin
export default {"wrapper":"Avatar_wrapper__UcLNI","avatar":"Avatar_avatar__CtzEe","dot":"Avatar_dot__7+kPs"};